import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBackends } from '../Internal/api';

export default function BackendInitializer() {
    const dispatch = useDispatch();
    const { availableBackends, currentBackend, loading } = useSelector(state => state.backend);

    useEffect(() => {
        // Only fetch backends if we don't have any and we're not already loading
        if (availableBackends.length === 0 && !loading && !currentBackend) {
            dispatch({ type: 'SET_BACKEND_LOADING', payload: true });
            
            fetchBackends(dispatch)
                .then(backends => {
                    dispatch({ type: 'SET_AVAILABLE_BACKENDS', payload: backends });
                    
                    // Auto-select the first backend if available
                    if (backends.length > 0) {
                        dispatch({ type: 'SET_CURRENT_BACKEND', payload: backends[0] });
                    }
                })
                .catch(err => {
                    console.error('Failed to load backends:', err);
                    dispatch({ type: 'SET_BACKEND_ERROR', payload: err.message });
                });
        }
    }, [availableBackends.length, loading, currentBackend, dispatch]);

    // This component doesn't render anything
    return null;
}
